import { render } from "./LongSleeve_2_front.vue?vue&type=template&id=e50b5f5e"
import script from "./LongSleeve_2_front.vue?vue&type=script&lang=js"
export * from "./LongSleeve_2_front.vue?vue&type=script&lang=js"

import exportComponent from "/srv/users/dyo-frontend-staging/apps/dyo-frontend-staging/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__